import { Property, File } from '../../types/property';

const getPdfs = (property: Property): File[] => {
  if (property.brochures) {
    return property.brochures;
  }

  if (property.files) {
    return property.files.filter((file) => file.fileType === 'pdfBrochure');
  }

  return [];
};

export default getPdfs;
